import React from 'react';
import PropTypes from 'prop-types';
import styles from '../CheckBoxFilters.module.scss';
import Icon from 'components/Icon/Icon';

function HiringCapacityCheckBox({
  hiringCapacity,
  onHiringCapacityToggle,
  checked,
}) {
  return (
    <div onClick={onHiringCapacityToggle} className={styles.checkBoxContainer}>
      <div className={styles.checkBoxIcon}>
        {checked && <Icon icon="&#xe60c;" color="#0ee2b0" />}
      </div>

      <div className={styles.checkBoxLabel}>
        <div className={styles.flexContainer}>
          {hiringCapacity.label === 'Commercial'
            ? 'Commercial / business work'
            : hiringCapacity.label === 'Personal'
            ? 'Personal projects'
            : hiringCapacity.label}
        </div>
      </div>
    </div>
  );
}

HiringCapacityCheckBox.propTypes = {
  hiringCapacity: PropTypes.object,
  onHiringCapacityToggle: PropTypes.func,
  checked: PropTypes.bool,
};

export default HiringCapacityCheckBox;
